import * as actionTypes from './actionTypes';
import axios from 'axios';
import axiosDurex from '../../axios-setup';
import {firebase, config} from '../../config/firebase';
//import storage from '../../config/firebase';
import Moment from 'moment';

const apiKey = config.apiKey;
//const dbUrl = fire.config.databaseURL;
//const storageBucket = config.storageBucket;

export const authStart = () => {
	return {
		type: actionTypes.AUTH_START
	};
};

export const authSuccess = (token, userId) => {
	return {
		type: actionTypes.AUTH_SUCCESS,
		idToken: token,
		userId: userId
	};
};

export const resetErrorState = () => {
	return {
		type: actionTypes.RESET_ERROR_STATE
	};
};

export const authFail = (error) => {
	//console.log('er: '+JSON.stringify(error));
	return {
		type:actionTypes.AUTH_FAIL,
		error: error
	};
};

export const auth = (email, password, typeOfForm, name, phone) => {
	return dispatch => {
		dispatch(authStart());
		let authData = {
			email: email,
			password: password,
			returnSecureToken: true
		}
		let url = '';

		if (typeOfForm==='login') {
			url = 'https://www.googleapis.com/identitytoolkit/v3/relyingparty/verifyPassword?key='+apiKey;
		} else if (typeOfForm==='signup') {
			url = 'https://www.googleapis.com/identitytoolkit/v3/relyingparty/signupNewUser?key='+apiKey;
		} else if (typeOfForm==='forgot') {
			url = 'https://www.googleapis.com/identitytoolkit/v3/relyingparty/getOobConfirmationCode?key='+apiKey;
			authData=null;
			authData = {
				email: email,
				requestType: 'PASSWORD_RESET'
			}
		}

		if (typeOfForm==='signup') {

			const urlPhone = 'https://us-central1-durex-quiz-11996.cloudfunctions.net/writePh?phone='+phone;

			// switch to firebase server functions
			axios.get(urlPhone)
			.then((response) => {
				//console.log(response.data);
				if (response.data['message'] === 'CAN_PLAY') {

					axios.post(url, authData)
					.then(response => {

						// add additional user information to the database
						if (typeOfForm==='signup') {
							const userData = {
									ime: name,
									tel: phone,
									eml: email,
							}
							const publicUserData = {
								ime: name
							}
							axiosDurex.put('/users/'+response.data.localId+'.json?auth='+response.data.idToken,userData)
								.then(()=> {
									//console.warn("additional user data written");
								})
								.catch((err) => {
									//console.warn("error writing additional user data: "+err)
								});
							axiosDurex.put('/usersPublic/'+response.data.localId+'.json?auth='+response.data.idToken,publicUserData)
								.then(()=> {
									//console.warn("additional public user data written");
								})
								.catch((err) => {
									//console.warn("error writing additional public user data: "+err)
								});
						}

						if (typeOfForm!=='forgot') {
							const expirationDate = new Date(new Date().getTime() + response.data.expiresIn * 1000);
							localStorage.setItem('token', response.data.idToken);
							localStorage.setItem('expirationDate', expirationDate);
							localStorage.setItem('userId', response.data.localId);
			
							// get avatar either from local storage or FB
							const avatar = localStorage.getItem('avatar');
							//console.log('checking local storage: ' + avatar);
							if (avatar) {
								//console.log('local storage avatar found');
								dispatch(setProfileAvatar(avatar))
							} else {
								//console.log('no local storage avatar found');
								dispatch(getAvatarLinkFromFB(response.data.idToken, response.data.localId));
							}
						}
			
						if (typeOfForm!=='forgot') {
							dispatch(authSuccess(response.data.idToken, response.data.localId));
							dispatch(checkAuthTimeout(response.data.expiresIn));
						}
			
		
					})
					.catch( (err) => {
						//console.log(err);
						dispatch(authFail(err.response.data.error));
					});

				} else if (response.data['message'] === 'CANT_PLAY') {
					dispatch(authFail({message:'PHONE_TAKEN'}))
				}
				return true;
			})
			.catch( (err) => {
				console.warn(err);
			})

		} else {
			axios.post(url, authData)
			.then(response => {
				if (typeOfForm!=='forgot') {
					const expirationDate = new Date(new Date().getTime() + response.data.expiresIn * 1000);
					localStorage.setItem('token', response.data.idToken);
					localStorage.setItem('expirationDate', expirationDate);
					localStorage.setItem('userId', response.data.localId);
	
					// get avatar either from local storage or FB
					const avatar = localStorage.getItem('avatar');
					//console.log('checking local storage: ' + avatar);
					if (avatar) {
						//console.log('local storage avatar found');
						dispatch(setProfileAvatar(avatar))
					} else {
						//console.log('no local storage avatar found');
						dispatch(getAvatarLinkFromFB(response.data.idToken, response.data.localId));
					}
				}
	
				if (typeOfForm!=='forgot') {
					dispatch(authSuccess(response.data.idToken, response.data.localId));
					dispatch(checkAuthTimeout(response.data.expiresIn));
				}
	
				if (response.data.kind === 'identitytoolkit#GetOobConfirmationCodeResponse') {
					dispatch(authFail({message:'EMAIL_RESET_SENT'}))
				}
			})
			.catch( (err) => {
				//console.log(err);
				dispatch(authFail(err.response.data.error));
			});
	
		}
	};
};

export const getResults = (uid) => {
	return dispatch => {
		dispatch(authStart());
		var userHighScores=[['Datum rezultata','Tačni odgovori', 'Postignuto vreme']];
		axiosDurex.get('/results/'+uid+'.json?orderBy="confirmed"&equalTo=true')
		.then ( response => {
			for (var key in response.data) {
				var dateStr = Moment(parseInt(key,10)).format("DD.MM.YYYY HH:mm");
				var result = response.data[key]['correctAnswers'];
				var gameTime = Moment(parseInt(response.data[key]['finalscore'],10)).format("mm:ss");
				userHighScores.push([dateStr,result,gameTime,key]);
			}
			userHighScores.sort(function(x, y){
				return x[3] - y[3];
			});
			dispatch(setResults(userHighScores));
		})
		.catch ( (err) => {
			console.log(err);
		})
	}
}

export const setResults = ( results ) => {
	return {
		type: actionTypes.SET_PROFILE_RESULTS,
		res: results
	};
}



export const logout = () => {
	localStorage.removeItem('token');
	localStorage.removeItem('expirationDate');
	localStorage.removeItem('userId');
	return {
		type: actionTypes.AUTH_LOGOUT
	};
};

export const checkAuthTimeout = (expirationTime) => {
    return dispatch => {
        setTimeout(() => {
            dispatch(logout());
		}, expirationTime * 1000);
		
		if (expirationTime > 300) {
			setTimeout(()=> {
				dispatch(logoutWarning(true));
				// 5 minutes
			}, (expirationTime-300)*1000);
		} else {
			dispatch(logoutWarning(true));
		}
    };
};

export const authCheckState = () => {
    return dispatch => {
		const token = localStorage.getItem('token');
        if (!token) {
            dispatch(logout());
        } else {
            const expirationDate = new Date(localStorage.getItem('expirationDate'));
            if (expirationDate <= new Date()) {
                dispatch(logout());
            } else {
                const userId = localStorage.getItem('userId');
				dispatch(authSuccess(token, userId));
				var expTime = (expirationDate.getTime() - new Date().getTime()) / 1000;
				dispatch(checkAuthTimeout(expTime));

				// get avatar either from local storage or FB
				const avatar = localStorage.getItem('avatar');
				//console.log('checking local storage: ' + avatar);
				if (avatar) {
					//console.log('local storage avatar found');
					dispatch(setProfileAvatar(avatar))
				} else {
					//console.log('no local storage avatar found');
					dispatch(getAvatarLinkFromFB(token, userId));
				}
            }
        }
    };
};

export const logoutWarning = ( warning ) => {
	return {
		type: actionTypes.SET_LOGOUT_WARNING,
		warn: warning
	}
}

export const getProfileSuccess = (profile) => {
	return {
		type: actionTypes.GET_PROFILE_SUCCESS,
		profile: profile
	}
};

export const getProfileFail = (error) => {
	return {
		type: actionTypes.GET_PROFILE_FAIL,
		error: error
	};
};

export const getProfileStart = () => {
	return {
		type: actionTypes.GET_PROFILE_START
	}
}

export const getProfile = (authToken, userID) => {
	//console.log('getProfile',authToken);
	return dispatch => {
		dispatch(getProfileStart());
		axiosDurex.get('/users/'+userID+'.json?auth='+authToken)
			.then( res => {
				const profileData = [];
				for (let key in res.data ) {
					profileData[key] = res.data[key];
				}
				dispatch(getProfileSuccess(profileData));
			} )
			.catch ( err => {
				dispatch(getProfileFail(err));
			})
	}
}

export const setAvatar = (imgData,uid,authToken) => {
	//localStorage.setItem('avatar', imgData);
	return dispatch => {
		dispatch(authStart());
		var stor = firebase.storage();
		var storageRef = stor.ref(uid).child('avatar.png');

		var metadata = {
			contentType: 'image/png'
		};

		var task = storageRef.putString(imgData, 'data_url', metadata);
		task.on('state_changed', function (snapshot) {

		}, function (error) {

		}, function () {
			task.snapshot.ref.getDownloadURL().then(function (downloadURL) {
				//console.log('dlurl',downloadURL);
				//dispatch(setProfileAvatar(imgData));
				localStorage.setItem('avatar', downloadURL); // set url localy 
				dispatch(setProfileAvatar(downloadURL)); // set it to store for this session
				dispatch(saveProfileAvatar(downloadURL,uid,authToken)); // save to fb profile
			})
		});
	}
}

export const removeAvatar = (uid,authToken) => {
	return dispatch => {
		dispatch(authStart());
		var stor = firebase.storage();
		var storageRef = stor.ref(uid).child('avatar.png');
		storageRef.getDownloadURL()
		.then( url => {
			//console.log(url);
			/*var task = */storageRef.delete();
			dispatch(unsetProfileAvatar());
			dispatch(saveProfileAvatar(null,uid,authToken));
			return true;
		})
		.catch ( (err) => {
			console.log('ERROR: '+err);
			dispatch(unsetProfileAvatar());
			dispatch(saveProfileAvatar(null,uid,authToken));
		})
		localStorage.removeItem('avatar');
	}		
}

export const setProfileAvatar = (url) => {
	return {
		type: actionTypes.SET_PROFILE_AVATAR,
		url: url
	}
}

export const unsetProfileAvatar = () => {
	return {
		type: actionTypes.DELETE_PROFILE_AVATAR,
	}
}

export const saveProfileAvatar = (url,uid,token) => {
	// saving to users FB branch
	return dispatch => {
		axiosDurex.patch('/users/'+uid+'.json?auth='+token,{
			'avatar': url
		})
		.then(()=> {
			//console.log('avatar set');
		})
		.catch((err)=> {
			console.log(err);
		});

		axiosDurex.patch('/usersPublic/'+uid+'.json?auth='+token,{
			'avatar': url
		})
		.then(()=> {
			//console.log('avatar public set');
		})
		.catch((err)=> {
			console.log(err);
		});

	}

}

export const getAvatarLinkFromFB = (token,uid) => {
	return dispatch => {
		axiosDurex.get('/users/'+uid+'.json?auth='+token)
		.then(response => {
			//console.log('get url from firebase: '+ response.data.avatar);
			if (response.data.avatar===undefined) {
				return true;
			} else {
				dispatch(setProfileAvatar(response.data.avatar));
				return true;
				/*
				axios.get(response.data.avatar, {
					responseType: 'arraybuffer',
					crossDomain: true
    			}).then(response => {
					const bin = Buffer.from(response.data, 'binary').toString('base64');
					console.log(bin);

				})
				.catch((err) => {
					//console.log('error getting binary image data from url: '+err)
				})
				*/
			}
			
		})
		.catch((err)=> {
			//console.log('no avatar in database: ' + err);
		});
	}
}


export const deleteProfile = (token, uid) => {
	return dispatch => {

		const url = 'https://us-central1-durex-quiz-11996.cloudfunctions.net/deleteUserData?uid='+uid;
		const deleteUrl = 'https://www.googleapis.com/identitytoolkit/v3/relyingparty/deleteAccount?key='+apiKey;
		const payload = {
			idToken: token
		}

		dispatch(authStart());
		dispatch(removeAvatar(uid,token));

		// switch to firebase server functions
		axios.get(url)
		.then((response) => {
			//console.log(response.data);
			if (response.data['message'] === 'USER_DATA_DELETED') {
				// delete actual user
				axios.post(deleteUrl, payload)
				.then ( response => {
					//console.warn('USER ACCOUNT DELETED');
					dispatch(logout());
					dispatch(doDeleteProfile());
				})
				.catch ( err => {
					//console.warn(err);
				})
			}
		})
		.catch((err)=> {
			console.log('ERROR_DELETING_USER_DATA:',err);
		});
	}
}

export const doDeleteProfile = () => {
	return {
		type: actionTypes.DELETE_PROFILE
	}	
}

export const checkLatestGame = (uid) => {
	return dispatch => {

		const url = 'https://us-central1-durex-quiz-11996.cloudfunctions.net/checkLatestGame?uid='+uid;

		dispatch(canPlayLoadingState(true));

		// switch to firebase server functions
		axios.get(url)
		.then((response) => {
			//console.log(response.data['message']);
			if (response.data['message'] === 'CAN_PLAY') {
				dispatch(canIPlay(true,null));
			} else if (response.data['message'] === 'CANT_PLAY') {
				var diff = parseInt(response.data['diff'],10);
				dispatch(canIPlay(false,diff));
			}
		})
		.catch((err)=> {
			console.log('ERROR_DELETING_USER_DATA:',err);
		});
	}
}

export const canPlayLoadingState = (st) => {
	return {
		type: actionTypes.CAN_PLAY_LOADING_STATE,
		loadingState: st
	}	
}

export const canIPlay = (st, ts) => {
	return {
		type: actionTypes.CAN_PLAY,
		canIplay: st,
		nextTimeStamp: ts
	}	
}


// WEBPACK FOOTER //
// ./src/store/actions/auth.js